import React from 'react';
import { price } from '../../utils/format';

const BriefDeliveryOption = ({ option }) => (
  <div className="getting-started_packages-item -info">
    <div className="getting-started_packages-item-title">{option.name}</div>
    {Boolean(option.price) && (
      <div className="getting-started_packages-item-price">+ {price(option.price)}</div>
    )}
    <div className="getting-started_packages-item-info">{option.description}</div>
  </div>
);

export default BriefDeliveryOption;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefDelivery/BriefDeliveryOption.js